import { Box, Flex } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import ButtonSolid from 'UiKit/button/buttonSolid';
import FilterSelect from 'UiKit/filter-select';
import SearchComponent from 'UiKit/search';
import { PlusIcon } from 'Asset/icon';
import useGetBrand from 'Domain/brand/useGetBrand';
import { getMenuPermissions } from 'Helper/getMenuPermissions';
import { Condition } from 'Component/others';

import { useScheduleRulesetState } from 'View/schedule-ruleset/state/';

import styles from './styles.module.css';

const Filter = () => {
  const { t } = useTranslation('schedule-ruleset');
  const accessPermission = getMenuPermissions('master-data', 'schedule-ruleset');
  const { filterState, updateFilterState, updateState } = useScheduleRulesetState();

  const { data: brandOptions } = useGetBrand();

  return (
    <Flex className={styles['filter-schedule-ruleset__wrapper']}>
      <Flex className={styles['filter-schedule-ruleset__container']}>
        <Flex className={styles['left__section']} gap={'12px'}>
          <SearchComponent width="377px" value={filterState?.search} debounceTime={300} onSearch={(search) => updateFilterState({ search, page: 1 })} />
          <Box>
            <FilterSelect
              placeholder={t('fieldPlaceholderBrand')}
              width="200px"
              isMulti={false}
              value={filterState?.brandId}
              clearable={true}
              onChange={(brandId) => updateFilterState({ brandId, page: 1 })}
              options={brandOptions}
            />
          </Box>
        </Flex>

        <Box className={styles['right__section']}>
          <Condition statement={accessPermission?.isCanCreate}>
            <ButtonSolid
              type="button"
              className={styles['filter-schedule-ruleset__button--create']}
              leftIcon={<PlusIcon width="14px" height="14px" />}
              onClick={() => updateState({ isOpenFormUpsert: true })}
            >
              {t('buttonAddText')}
            </ButtonSolid>
          </Condition>
        </Box>
      </Flex>
    </Flex>
  );
};

export default Filter;